export enum QueryKeys {
    products = "products",
    resources = "resources",
    propertyKeys = "propertyKeys",
    companySettings = "companySettings",
    instances = "instances",
    overview = "overview",




    customers = "customers",
    orders = "orders",
    worksites = "worksites",
    jobSummary = "jobSummary",
    resetPassword = "resetPassword",
    systemSettings = "systemSettings",

    templates = "templates",
    dashboard = "dashboard",
    default = "default",
    users = "users",
}